import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [RouterModule]
})
export class AppComponent implements OnInit,OnDestroy {
  router = inject(Router);
  private auth = inject(AuthService);
  private onlineStatusService = inject(OnlineStatusService);


  private userSub: Subscription
  public isAuthenticated: boolean;

  constructor() {

      console.log(environment.nonce);
      this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {
        // Retrieve Online status Type
        console.log(status)
      });
  }

  async ngOnInit() {
     this.auth.autoLogin();

    this.userSub = this.auth.user.subscribe(user =>
    {
      this.isAuthenticated = !user ? false : true;

    });


  }

  ngOnDestroy(): void {
      this.userSub.unsubscribe();
  }



}
